<script setup lang="ts">
import { sentryUtils } from '@/lib/sentry'
import { QuestionMarkCircledIcon } from '@radix-icons/vue'
import Button from './ui/button/Button.vue'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './ui/tooltip'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

const openFeedbackDialog = () => {
    sentryUtils.openFeedbackForm()
}
</script>

<template>
    <TooltipProvider>
        <Tooltip>
            <TooltipTrigger as-child>
                <Button variant="icon" size="icon-sm" @click="openFeedbackDialog">
                    <FontAwesomeIcon icon="fa-light fa-bug" />
                </Button>
            </TooltipTrigger>
            <TooltipContent side="left">
                <p>Report an issue</p>
            </TooltipContent>
        </Tooltip>
    </TooltipProvider>
</template>
